


























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import MenuItem from '../../models/menu-item.model'
import { Location } from 'vue-router'

@Component
export default class LeftMenu extends Vue {
    @Prop() drawer!: boolean
    @Prop() loading!: boolean
    @Prop({ default: [] }) items: MenuItem[]
    @Prop({ default: true }) global: boolean
    @Prop({ default: false }) editMode: boolean

    localDrawer = false
    localModel = true
    clipped = true

    @Watch('drawer')
    updateDrawer () {
        this.localDrawer = !this.localDrawer
    }

    goToRoute (route: {name: string; params: object|null}) {
        if (this.editMode || route.name === '-') return
        if (route.params == null) {
            route.params = {}
        }

        this.$forceUpdate()

        const resolved = this.$router.resolve(route as Location)
        this.$router.push(resolved.route as Location)
    }

    mounted () {
        setTimeout(() => {
            if (!this.$vuetify.breakpoint.mdAndDown) {
                this.localDrawer = true
            } else {
                this.localDrawer = false
            }
        }, 500)
    }
}
